import { __extends } from "tslib";
import { Announced, Callout, CommandButton, DirectionalHint, FocusZone, FocusZoneDirection, FontIcon, getFirstFocusable, getId, getLastFocusable, initializeComponentRef, KeyCodes, Link, mergeStyles, safeRequestAnimationFrame, Spinner, SpinnerSize, Stack, Text } from '@fluentui/react';
import React from 'react';
import { announcedBGColor, RecentSearchBtnStyles, RecentSearchText, SearchLoader, ShowMoreLinkStyles, SuggestionCategoryHeaderText, suggestionRowCommandBtnStyles } from './GlobalSearch.styles';
import { ErrorMessage } from './InternalGlobalSearch.types';
import { SearchPersona } from './SearchPersona';
var AutoSuggestDropdown = (function (_super) {
    __extends(AutoSuggestDropdown, _super);
    function AutoSuggestDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this._focusZone = React.createRef();
        _this._host = React.createRef();
        _this._requestAnimationFrame = safeRequestAnimationFrame(_this);
        _this._onRenderRecentSearchRow = function (recentSearchItem, index) {
            return (React.createElement(Stack, { grow: true, verticalFill: true, key: recentSearchItem.id + index },
                React.createElement(CommandButton, { key: 'recentSearch' + index + recentSearchItem.text, iconProps: { iconName: 'Clock' }, className: mergeStyles(_this.props.styles.searchSuggestionItem), styles: RecentSearchBtnStyles(_this.props.theme), ariaLabel: recentSearchItem.text, role: 'link', "data-is-focusable": true, onClick: function () { return _this._onClickSuggestion(recentSearchItem); } },
                    React.createElement("div", { className: RecentSearchText(_this.props.theme) }, recentSearchItem.text))));
        };
        _this._onRenderSuggestionsList = function (suggestions, recentSearchTexts) {
            return (React.createElement(Stack, { grow: true, verticalFill: true },
                React.createElement("div", null, recentSearchTexts.map(function (text, index) {
                    return _this._onRenderRecentSearchRow(text, index);
                })),
                React.createElement("div", null, suggestions.map(function (obj) {
                    var category = obj.category !== null && obj.category !== undefined ? obj.category : '';
                    var _suggestionItems = obj.suggestions.slice(0, _this.props.suggestionsCount);
                    return React.createElement(Stack, { grow: true, verticalFill: true, className: mergeStyles(_this.props.styles.searchSuggestionList), key: category },
                        React.createElement("div", { className: mergeStyles(_this.props.styles.suggestionCategoryHeader) },
                            React.createElement(Text, { className: SuggestionCategoryHeaderText(_this.props.theme), id: category }, category)),
                        _suggestionItems.map(function (x, index) {
                            return (React.createElement(CommandButton, { key: 'searchsuggestion' + index + x.text, className: mergeStyles(_this.props.styles.searchSuggestionItem), styles: suggestionRowCommandBtnStyles(_this.props.theme), role: 'link', ariaLabel: x.text, "data-is-focusable": true, "aria-describedby": category, onClick: function () { return _this._onClickSuggestion(x, category); } },
                                React.createElement(SearchPersona, { key: x.text, text: x.text, secondaryText: x.secondaryText, isPerson: x.isPerson, imageUrl: x.imageUrl, theme: _this.props.theme })));
                        }));
                })),
                suggestions.length > 0 &&
                    React.createElement("div", { className: mergeStyles(_this.props.styles.showMoreResultsLink) },
                        React.createElement(Link, { className: ShowMoreLinkStyles, onClick: _this._onShowMoreResults, role: 'link', "aria-label": 'Show more results' }, "Show more results"))));
        };
        _this._onClickSuggestion = function (suggestion, category) {
            if (_this.props.OnClickSuggestionItem) {
                _this.props.OnClickSuggestionItem(suggestion, category);
            }
        };
        _this._onShowMoreResults = function () {
            if (_this.props.OnShowMoreResults) {
                _this.props.OnShowMoreResults();
            }
        };
        _this._onZoneKeyDown = function (ev) {
            var elementToFocus;
            var containsExpandCollapseModifier = ev.altKey || ev.metaKey;
            switch (ev.which) {
                case KeyCodes.up:
                    if (containsExpandCollapseModifier) {
                        _this.props.CloseAutosuggest();
                    }
                    else {
                        if (_this._host.current) {
                            elementToFocus = getLastFocusable(_this._host.current, _this._host.current.lastChild, true);
                        }
                    }
                    break;
                case KeyCodes.home:
                case KeyCodes.end:
                case KeyCodes.pageUp:
                case KeyCodes.pageDown:
                    break;
                case KeyCodes.enter:
                    return;
                case KeyCodes.down:
                    if (!containsExpandCollapseModifier && _this._host.current) {
                        elementToFocus = getFirstFocusable(_this._host.current, _this._host.current.firstChild, true);
                    }
                    break;
                case KeyCodes.escape:
                    _this.props.CloseAutosuggest();
                    break;
                case KeyCodes.tab:
                    _this.props.CloseAutosuggest();
                    return;
                default:
                    return;
            }
            if (elementToFocus) {
                elementToFocus.focus();
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this.focus = function () {
            if (_this._focusZone.current) {
                _this._requestAnimationFrame(function () {
                    if (_this._focusZone.current) {
                        _this._focusZone.current.focus();
                    }
                });
            }
        };
        initializeComponentRef(_this);
        return _this;
    }
    AutoSuggestDropdown.prototype.render = function () {
        var _a = this.props, recentSearchTexts = _a.recentSearchTexts, target = _a.target, suggestions = _a.suggestions, isLoading = _a.isLoading, showSearchSuggestions = _a.showSearchSuggestions, OnCalloutDismissCallback = _a.OnCalloutDismissCallback, isError = _a.isError, errorMessage = _a.errorMessage, recentSearchTextsCount = _a.recentSearchTextsCount, searchCategoryCount = _a.searchCategoryCount, id = _a.id, styles = _a.styles, theme = _a.theme;
        var _recentSearchTexts = (recentSearchTexts && recentSearchTexts.length > 0) ? recentSearchTexts.slice(0, recentSearchTextsCount) : [];
        var _suggestions = (suggestions && suggestions.length > 0) ? suggestions.slice(0, searchCategoryCount) : [];
        var _isLoading = (isLoading === null || isLoading === undefined) ? false : isLoading;
        var _isError = (isError === null || isError === undefined) ? false : isError;
        var _errorMessage = (errorMessage === null || errorMessage === undefined || errorMessage === '') ? ErrorMessage : errorMessage;
        var _id = (id !== null || id !== undefined) ? id : getId();
        return React.createElement(Callout, { id: _id, isBeakVisible: false, gapSpace: 6, doNotLayer: false, directionalHintFixed: true, directionalHint: DirectionalHint.bottomLeftEdge, minPagePadding: 0, coverTarget: false, target: target.current, alignTargetEdge: false, onDismiss: OnCalloutDismissCallback, className: mergeStyles(styles.autoSuggestDropdown), calloutWidth: target.current ? target.current.clientWidth : 0, role: "dialog", "aria-label": "Search dialog" },
            _suggestions.length > 0 && React.createElement(Announced, { styles: announcedBGColor(theme), message: _suggestions.length + ' search results found' }),
            React.createElement("div", { id: 'autoSuggestdropdownCallout', onKeyDown: this._onZoneKeyDown, ref: this._host },
                React.createElement(FocusZone, { direction: FocusZoneDirection.vertical, ref: this._focusZone }, _isError ?
                    React.createElement("div", { className: mergeStyles(styles.errorMessage) },
                        React.createElement(FontIcon, { iconName: 'Warning' }),
                        React.createElement(Text, { variant: 'medium' }, _errorMessage))
                    :
                        _isLoading
                            ?
                                React.createElement("div", null,
                                    React.createElement(Spinner, { className: SearchLoader(theme), size: SpinnerSize.small, label: 'Loading...', ariaLive: 'polite', labelPosition: 'right' }))
                            : showSearchSuggestions
                                ? this._onRenderSuggestionsList(_suggestions, _recentSearchTexts)
                                : React.createElement(React.Fragment, null))));
    };
    return AutoSuggestDropdown;
}(React.Component));
export { AutoSuggestDropdown };
//# sourceMappingURL=AutoSuggestDropdown.js.map